// extracted by mini-css-extract-plugin
module.exports = {"list":"GroupsList_list___Xo9W","item":"GroupsList_item__fhFTr","itemButton":"GroupsList_itemButton__IaJIW","divider":"GroupsList_divider__hgs0w"};